import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tab__container" }

import { useRoute } from 'vue-router';
import { i18n } from '@/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderPageTab',
  setup(__props) {

const t = i18n.t;
const route = useRoute();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, { to: "/firm-order" }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(_unref(route).path === '/firm-order' ? 'tab__active' : 'tab__inactive')
        }, _toDisplayString(_unref(t)('テーブル(発注ページ)')), 3)
      ], undefined, true),
      _: 1
    }),
    _createVNode(_component_router_link, { to: "/order-calendar" }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(_unref(route).path === '/order-calendar' ? 'tab__active' : 'tab__inactive')
        }, _toDisplayString(_unref(t)('カレンダー(発注ページ)')), 3)
      ], undefined, true),
      _: 1
    })
  ]))
}
}

})